import { color, DataItem, Root, Series } from '@amcharts/amcharts5';
import { IColumnSeriesDataItem } from '@amcharts/amcharts5/xy';
import React from 'react';
import { renderToString } from 'react-dom/server';

import { State } from 'features/Frames/types';
import StatusHistoryTooltip from 'features/Status/components/StatusHistory/StatusHistoryChart/StatusHistoryTooltip';
import { StatusData } from 'features/Status/types/statusData';
import { stateColour, stateColourString, stateFormatter } from 'features/Status/utils/state';
import { bullet, circle, toolTip } from 'utils/charts/charts';
import { SHADOW, WHITE } from 'utils/colours';

export const createBullets = (series: Series) => {
  series.bullets.push((currentRoot: Root, _: Series, dataItem: DataItem<IColumnSeriesDataItem>) => {
    const statusDataContext = dataItem.dataContext as StatusData;
    const date = new Date(statusDataContext.time);
    const time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}`;
    const tooltip = toolTip(currentRoot, {
      getFillFromSprite: false,
      getStrokeFromSprite: false,
      pointerOrientation: 'up',
    });
    tooltip.get('background')?.setAll({
      fill: color(WHITE),
      fillOpacity: 1,
      shadowColor: color(SHADOW),
      shadowBlur: 16,
      shadowOffsetX: 0,
      shadowOffsetY: 4,
      shadowOpacity: 0.25,
    });

    const statusColour = stateColourString(statusDataContext.state);
    const tooltipColour = stateColour(statusDataContext.state as State);
    const stateString = stateFormatter(statusDataContext.state as State);

    return bullet(currentRoot, {
      sprite: circle(currentRoot, {
        fill: statusColour,
        radius: 9,
        tooltip: tooltip,
        tooltipHTML: renderToString(
          <StatusHistoryTooltip statusColour={tooltipColour} state={stateString} time={time} />
        ),
      }),
    });
  });
};
